module.exports = __webpack_public_path__ + "img/header_separator.c397b8a2.svg";